import React from 'react';
import { styles } from './HeadingDivider.css';
import { LinkIcon } from '../LinkIcon/LinkIcon';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { HEADING_FONT_VARIANTS, HeadingFont, HeadingFontVariant } from './HeadingFont';

export enum HeadingDividerVariant {
  small = 'small',
  default = 'default',
  large = 'large',
}

export type HeadingDividerProps = {
  heading: string | React.ReactNode;
  href?: string;
  shouldOpenInNewWindow?: boolean;
  textColor?: string;
  variant?: HeadingDividerVariant;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>;
  className?: string;
  style?: React.CSSProperties;
  headingFontVariant?: HeadingFontVariant;
  shadowVariant?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

export const HeadingDivider: React.FunctionComponent<HeadingDividerProps> = ({
  heading,
  href,
  shouldOpenInNewWindow = false,
  textColor = 'black',
  variant = HeadingDividerVariant.default,
  onClick,
  className,
  style,
  headingFontVariant = HEADING_FONT_VARIANTS.JBCallout,
  shadowVariant,
  as,
}) => {
  const isLink = !!href;

  return React.createElement(
    isLink ? 'a' : 'div',
    {
      className: classNames(styles.container({ variant }), className),
      onClick,
      style: { color: textColor, ...style },
      ...(isLink
        ? {
            href,
            ...(shouldOpenInNewWindow ? { target: '_blank', rel: 'noreferrer' } : {}),
          }
        : {}),
    },
    <HeadingFont variant={headingFontVariant} as={as} className={styles.heading} shadowVariant={shadowVariant}>
      {heading}
      {isLink ? <LinkIcon className={styles.icon} /> : null}
    </HeadingFont>
  );
};
